import * as React from 'react';
import { navigation } from '../../../../styles/colors';
import { SvgIcon } from '../SvgIcon';

interface Props extends React.ComponentProps<'svg'> {
	fillColor?: string;
}

export const BulletIcon = ({ className, fillColor, height = 6, width = 6, ...props }: Props) => {
	return (
		<SvgIcon className={`bullet-icon ${className || ''}`} height={height} width={width} viewBox='0 0 6 6' {...props}>
			<circle cx='3' cy='3' r='3' fill={fillColor || navigation} fillRule='evenodd' />
		</SvgIcon>
	);
};
